import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import DatePicker from 'react-datepicker';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class StaffFlightTotalsDisponibility extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      current: '',
      next: '',
      previous: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.search = this.search.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleChangeDatePicker (state, date) {
    var change = {};
    change[state] = date.format("DD/MM/YYYY");
    this.setState(change);
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      var now = new Date();
      var month = (now.getMonth()) + 1;
      var year = now.getFullYear();
      var day = now.getDate();
      if (day < 10) {
        day = '0' + day;
      }
      if (month < 10) {
        month = '0' + month;
      }
      var reference = day + '/' + month + '/' + year;
      this.setState({loaded: 2}, this.loadData(reference));
    }
  }
  componentWillMount () {
      var today = new Date();
      var offset = -(today.getTimezoneOffset()/60);
      var today_str = new Date( new Date().getTime() + offset * 3600 * 1000).toJSON().slice(0,10).split('-').reverse().join('/');

      this.setState({date_start: today_str});
  }

  loadData(reference) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/disponibilidade/tripulantes/' + reference, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data.index_data, current: responseJson.data.current, previous: responseJson.data.previous, next: responseJson.data.next});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  fatigueLabel (cell, row) {
    if (row.actual_points_limit === 'yellow') {
      var botao = (
        <span style={{fontWeight: "bold", color:"orange"}}>{cell}</span>
      );
    } else if(row.actual_points_limit === 'red') {
      var botao = (
        <span style={{fontWeight: "bold", color:"red"}}>{cell}</span>
      );
    } else {
      var botao = (
        <span>{cell}</span>
      );
    }

    return botao;
  }

  totalTimeLabel (cell, row) {
    if (row.total_time_limit === 'yellow') {
      var botao = (
        <span style={{fontWeight: "bold", color:"orange"}}>{cell}</span>
      );
    } else if(row.total_time_limit === 'red') {
      var botao = (
        <span style={{fontWeight: "bold", color:"red"}}>{cell}</span>
      );
    } else {
      var botao = (
        <span>{cell}</span>
      );
    }

    return botao;
  }

  hoursMonthLabel (cell, row) {
    if (row.hours_month_limit === 'yellow') {
      var botao = (
        <span style={{fontWeight: "bold", color:"orange"}}>{cell}</span>
      );
    } else if(row.hours_month_limit === 'red') {
      var botao = (
        <span style={{fontWeight: "bold", color:"red"}}>{cell}</span>
      );
    } else {
      var botao = (
        <span>{cell}</span>
      );
    }

    return botao;
  }

  hoursYearLabel (cell, row) {
    if (row.hours_year_limit === 'yellow') {
      var botao = (
        <span style={{fontWeight: "bold", color:"orange"}}>{cell}</span>
      );
    } else if(row.hours_year_limit === 'red') {
      var botao = (
        <span style={{fontWeight: "bold", color:"red"}}>{cell}</span>
      );
    } else {
      var botao = (
        <span>{cell}</span>
      );
    }

    return botao;
  }

  hoursJourneyMonthLabel (cell, row) {
    if (row.hours_journey_month_limit === 'yellow') {
      var botao = (
        <span style={{fontWeight: "bold", color:"orange"}}>{cell}</span>
      );
    } else if(row.hours_journey_month_limit === 'red') {
      var botao = (
        <span style={{fontWeight: "bold", color:"red"}}>{cell}</span>
      );
    } else {
      var botao = (
        <span>{cell}</span>
      );
    }

    return botao;
  }

  hoursNocturnLabel (cell, row) {
    if(row.hours_nocturn_limit === 'red') {
      var botao = (
        <span style={{fontWeight: "bold", color:"red"}}>{cell}</span>
      );
    } else {
      var botao = (
        <span>{cell}</span>
      );
    }

    return botao;
  }

  hoursExternalLabel (cell, row) {
    if(row.hours_external_load_limit === 'red') {
      var botao = (
        <span style={{fontWeight: "bold", color:"red"}}>{cell}</span>
      );
    } else {
      var botao = (
        <span>{cell}</span>
      );
    }

    return botao;
  }
  asoLabel (cell, row) {
    if(row.aso_limit === 'red') {
      var botao = (
        <span style={{fontWeight: "bold", color:"red"}}>{cell}</span>
      );
    } else {
      var botao = (
        <span>{cell}</span>
      );
    }

    return botao;
  }

  hoursDaysLabel (cell, row) {
   if(row.captain_trigger === 1) {
      var botao = (
        <span style={{fontWeight: "bold", color:"red"}}>{cell}</span>
      );
    } else {
      var botao = (
        <span>{cell}</span>
      );
    }

    return botao;
  }

  next() {
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    this.loadData(this.state.next);
  }

  previous() {
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    this.loadData(this.state.previous);
  }

  search(event) {
    var self = this;
    event.preventDefault();
    this.setState({loaded: 2}, this.loadData(this.state.date_start));
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <div className="row">
        <div className="col-md-4">
          <button className="btn btn-primary" onClick={this.previous}><i className="fa fa-fw fa-chevron-left"></i> {this.state.previous}</button>
        </div>
        <div className="col-md-4">
          <h3 className="page-title text-center">{this.state.current}</h3>
        </div>
        <div className="col-md-4 text-right">
          <button className="btn btn-primary" onClick={this.next}>{this.state.next} <i className="fa fa-fw fa-chevron-right"></i></button>
        </div>
      </div>
      <hr/>
      <h3 className="page-title pull-left">{this.locale.VoosTotais.DisponibilidadeDeTripulantes.titulo}</h3>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.search}>
        <div className="row">
          <div className="col-md-3 col-md-offset-3">
            <div className="form-group">
              <DatePicker value={this.state.date_start} onChange={this.handleChangeDatePicker.bind(this, 'date_start')} className="form-control" />
            </div>
          </div>
          <div className="col-md-3">
            <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-search"></i> {this.locale.VoosTotais.DisponibilidadeDeTripulantes.formulario.botaoMudarData}</button>
          </div>
        </div>
      </form>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.VoosTotais.DisponibilidadeDeTripulantes.tabela.semProgramacaoParaHoje}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>
        <TableHeaderColumn dataField="inscription" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='90'>{this.locale.VoosTotais.DisponibilidadeDeTripulantes.tabela.Matricula}</TableHeaderColumn>
        <TableHeaderColumn dataField="nickname" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='250'>{this.locale.VoosTotais.DisponibilidadeDeTripulantes.tabela.NomeDeGuerra}</TableHeaderColumn>
        <TableHeaderColumn dataField="role_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='250'>{this.locale.VoosTotais.DisponibilidadeDeTripulantes.tabela.Cargo}</TableHeaderColumn>
        <TableHeaderColumn dataField="base" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='250'>{this.locale.VoosTotais.DisponibilidadeDeTripulantes.tabela.Base}</TableHeaderColumn>
        <TableHeaderColumn dataField="aircraft" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='250'>{this.locale.VoosTotais.DisponibilidadeDeTripulantes.tabela.Aeronave}</TableHeaderColumn>
        <TableHeaderColumn dataField="aircraft_model" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='250'>{this.locale.VoosTotais.DisponibilidadeDeTripulantes.tabela.Frota}</TableHeaderColumn>
        <TableHeaderColumn dataField="total_time" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='290' dataFormat={this.totalTimeLabel}>{this.locale.VoosTotais.DisponibilidadeDeTripulantes.tabela.HorasRealizadasDisponiveisDia}</TableHeaderColumn>
        <TableHeaderColumn dataField="hours_month" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='290' dataFormat={this.hoursMonthLabel}>{this.locale.VoosTotais.DisponibilidadeDeTripulantes.tabela.HorasRealizadasDisponiveisMes}</TableHeaderColumn>
        <TableHeaderColumn dataField="hours_year" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='290' dataFormat={this.hoursYearLabel}>{this.locale.VoosTotais.DisponibilidadeDeTripulantes.tabela.HorasRealizadasDisponiveisAno}</TableHeaderColumn>
        <TableHeaderColumn dataField="hours_day" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='290' dataFormat={this.hoursDaysLabel}>{this.locale.VoosTotais.DisponibilidadeDeTripulantes.tabela.HorasRealizadasUltimos30Dias}</TableHeaderColumn>
        <TableHeaderColumn dataField="hours_journey_month" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='250' dataFormat={this.hoursJourneyMonthLabel}>{this.locale.VoosTotais.DisponibilidadeDeTripulantes.tabela.JornadaMensal}</TableHeaderColumn>
        <TableHeaderColumn dataField="hours_nocturn" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='250' dataFormat={this.hoursNocturnLabel}>{this.locale.VoosTotais.DisponibilidadeDeTripulantes.tabela.ExperienciaNoturna}</TableHeaderColumn>
        <TableHeaderColumn dataField="hours_external_load" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='250' dataFormat={this.hoursExternalLabel}>{this.locale.VoosTotais.DisponibilidadeDeTripulantes.tabela.CargaExterna}</TableHeaderColumn>
        <TableHeaderColumn dataField="aso" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='250' dataFormat={this.asoLabel}>{this.locale.VoosTotais.DisponibilidadeDeTripulantes.tabela.ValidadeASO}</TableHeaderColumn>
      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default StaffFlightTotalsDisponibility;



// WEBPACK FOOTER //
// ./src/Components/StaffFlightTotals/StaffFlightTotalsDisponibility.js